module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp2_7016.b040a2e9.png";